import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone, faEnvelope, faPaperPlane, faClock } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faTwitter, faInstagram, faPinterest, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import useScrollReveal from "../hooks/useScrollReveal";
import "../Styles/Contact.css";

function Contact() {
  useScrollReveal();
  const [formData, setFormData] = useState({ firstName: "", lastName: "", email: "", phone: "", subject: "", message: "" });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Message sent successfully! We'll get back to you within 24 hours.", { position: "top-center", autoClose: 4000 });
    setFormData({ firstName: "", lastName: "", email: "", phone: "", subject: "", message: "" });
  };

  return (
    <div className="contact-page">
      <Navbar />
      <ToastContainer />

      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <span className="section-tag">Get In Touch</span>
          <h1 className="page-hero-title">Let's Start A<br/>Conversation</h1>
          <p className="page-hero-subtitle">
            Have questions about financial planning? Ready to take the next step? We'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section section-padding reveal">
        <div className="container">
          <div className="contact-grid">
            {/* Left - Info */}
            <div className="contact-info">
              <h3>Contact Information</h3>
              <p className="contact-info-subtitle">Reach out anytime. We typically respond within 24 hours.</p>
              
              <div className="contact-details">
                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                  <div>
                    <h5>Visit Us</h5>
                    <p>6160 Summit Dr N Suite#145<br/>Brooklyn Center, MN 55429</p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FontAwesomeIcon icon={faPhone} />
                  </div>
                  <div>
                    <h5>Call Us</h5>
                    <p>+1 763-271-9700</p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div>
                    <h5>Email Us</h5>
                    <p>financialsolutions@ebenwealth.com</p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-detail-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <h5>Business Hours</h5>
                    <p>Mon - Fri: 9:00 AM - 6:00 PM<br/>Sat: By Appointment</p>
                  </div>
                </div>
              </div>

              <div className="contact-socials">
                <a href="https://www.facebook.com/people/Ebenwealth/61578519344274/" target="_blank" rel="noreferrer" aria-label="Facebook"><FontAwesomeIcon icon={faFacebookF} /></a>
                <a href="https://x.com/ebenwealthh" target="_blank" rel="noreferrer" aria-label="Twitter"><FontAwesomeIcon icon={faTwitter} /></a>
                <a href="https://www.instagram.com/ebenwealth7/" target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
                <a href="https://www.pinterest.com/ebenwealth/" target="_blank" rel="noreferrer" aria-label="Pinterest"><FontAwesomeIcon icon={faPinterest} /></a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
              </div>
            </div>

            {/* Right - Form */}
            <div className="contact-form-wrap">
              <h3>Send Us A Message</h3>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>First Name *</label>
                    <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} required placeholder="John" />
                  </div>
                  <div className="form-group">
                    <label>Last Name *</label>
                    <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required placeholder="Doe" />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="john@example.com" />
                  </div>
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="+1 (000) 000-0000" />
                  </div>
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <select name="subject" value={formData.subject} onChange={handleChange}>
                    <option value="">Select a topic...</option>
                    <option value="life-insurance">Life Insurance</option>
                    <option value="retirement">Retirement Planning</option>
                    <option value="education">Financial Education</option>
                    <option value="business">Business Protection</option>
                    <option value="kai-zen">Kai-Zen Plan</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Message *</label>
                  <textarea name="message" rows="5" value={formData.message} onChange={handleChange} required placeholder="Tell us how we can help..."></textarea>
                </div>
                <button type="submit" className="btn-primary contact-submit">
                  <FontAwesomeIcon icon={faPaperPlane} /> Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;
